// @flow
import React from 'react';
import CardCarousel from '@homeaway/react-card-carousel';
import PropertyCard from './PropertyCard/PropertyCard';
import LoadingCard from './LoadingCard/LoadingCard';
import type {PropertyCardListingShape} from './PropertyCard/PropertyCard';
import {listingsMockData} from './listingsMockData';

export type RecentlyViewedPropertyShape = {
    listing: PropertyCardListingShape
};

type Props = {
    isMobile: boolean,
    title: string,
    breakpoints: Object,
    isDataLoading: Boolean,
    onCardsShownChange: Function,
    listings: RecentlyViewedPropertyShape[]
};

const renderCards = (listings, isMobile) => {
    return listings.map(({listing}) => (
        <PropertyCard
            listing={listing}
            isMobile={isMobile}
            key={listing.listingId}
        />
    ));
};

export const PropertyCarousel = (props: Props) => {
    const {
        isMobile,
        title,
        breakpoints,
        isDataLoading,
        onCardsShownChange
    } = props;

    const listings = listingsMockData;

    return (
        <CardCarousel
            breakpoints={breakpoints}
            scrolling={isMobile}
            title={title}
            onCardsShownChange={onCardsShownChange}
        >
            {renderCards(listings, isMobile)}
            {isMobile && isDataLoading && <LoadingCard />}
        </CardCarousel>
    );
};

export default PropertyCarousel;
